var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 0C4.17206 0 0 4.17206 0 9.3C0 14.4279 4.17206 18.6 9.3 18.6C14.4279 18.6 18.6 14.4279 18.6 9.3C18.6 4.17206 14.4279 0 9.3 0ZM2.325 9.3C2.325 7.79593 2.80833 6.40532 3.62104 5.26488L13.3351 14.979C12.1947 15.7917 10.8041 16.275 9.3 16.275C5.45376 16.275 2.325 13.1462 2.325 9.3ZM14.9789 13.3351L5.26485 3.62104C6.40528 2.80834 7.7959 2.325 9.29996 2.325C13.1462 2.325 16.275 5.45376 16.275 9.3C16.275 10.8041 15.7916 12.1947 14.9789 13.3351Z",
    fill: "#F96056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageFailed);
export default __webpack_public_path__ + "static/media/message-failed.b291327b7fa5f1a0de86619178e99a3e.svg";
export { ForwardRef as ReactComponent };